// extracted by mini-css-extract-plugin
export default {"mobile":"(max-width: 767px)","small_mobile":"(max-width: 450px)","ultra_small_mobile":"(max-width: 370px)"};